import React, { useEffect, useRef, useState } from "react";
import MolGrid from "../../../../components/molGrid/MolGrid";
import {viewSchemaDataGridConfig} from "./viewSchemaFieldModelData.config";
import CenterModal from "../../../../components/ui/centerModal/CenterModal";
import MappingSchemaField from "./MappingSchemaField";
import { useLazyGetXMLReportFieldsForMappingQuery } from "../../../../app/services/reportTemplateAPI";
import PropTypes from "prop-types";

const ViewSchemaFieldModel = ({reportTemplateID,xmlTemplateId,xmlReportId}) => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState([]);
  const [isXSDTemplateModelOpen, setIsXSDTemplateModelOpen] = useState(false);
  const [selectedRow,setSelectedRow]=useState({})
  const [isloadingData,setIsloadingData]= useState(true)
  const [selectRow, setSelectrow] = useState("");

  const [getXMLReportFieldsForMapping, {
    isLoading: isXmlSchemaReportLoading,
    isFetching:isXmlSchemaReportFetching,
    isSuccess: isXmlSchemaReportSuccess,
    data: XmlSchemaReporttData,
  }] =useLazyGetXMLReportFieldsForMappingQuery();


  useEffect(()=>{
    if (xmlReportId) {
      getXMLReportFieldsForMapping(xmlReportId)  
    }
  },[xmlReportId])

  useEffect(() => {
    if (!isXmlSchemaReportFetching && isXmlSchemaReportSuccess) {
      function buildTree(XmlSchemaReporttData, parentId = 0) {
        return XmlSchemaReporttData
          .filter(item => item.xmlSchemaFieldParentID === parentId)
          .map(item => ({
            ...item,
            children: buildTree(XmlSchemaReporttData, item.xmlSchemaField)
          }));
      }
      function flattenTreeWithPrefixes(nodes, level = 0) {
        let result = [];
      
        nodes.forEach(node => {
          const spacePrefix =  '   '.repeat(level + 1);
          const prefix = level > 0 ? `${spacePrefix}|__` : '';
          result.push({
            ...node,
            displayName: `${prefix}${node.schemaFieldName}`
          });
      
          if (node.children && node.children.length > 0) {
            result = result.concat(flattenTreeWithPrefixes(node.children, level + 1));
          }
        });
        return result;
      }  
      const tree = buildTree(XmlSchemaReporttData, 0);
      const flattened = flattenTreeWithPrefixes(tree);
      let updatedData = flattened.map(({children,...item}) => ({
        ...item,
        onCustomButtonClick: handleCustomColumnButtonClick,
      }));
      setDataSource(updatedData);
      setIsloadingData(isXmlSchemaReportFetching && XmlSchemaReporttData.length < 0 ? true : false);
    }
  }, [isXmlSchemaReportFetching, isXmlSchemaReportSuccess, XmlSchemaReporttData]);

  const handleCustomColumnButtonClick = (rowData) => {
    setSelectedRow(rowData)
    setIsXSDTemplateModelOpen(true);
  };

  const handleSucces = ()=>{
    getXMLReportFieldsForMapping(xmlReportId)
    handleCloseModel()
  }

  const handleCloseModel = () => {
    setIsXSDTemplateModelOpen(false);
    setSelectedRow({})
  };

  const handleRowSelect = (rowData) => {
    setSelectrow(rowData.reportTemplateFieldID)
  };

  const actionHandler = {};
  return (
    <div>
      <div className="">
        <div className="">
          <MolGrid
            ref={molGridRef}
            configuration={viewSchemaDataGridConfig}
            dataSource={dataSource}
            allowPagination={false}
            selectRow={selectRow}
            pagination={{
              totalCount: dataSource.length,
              pageSize: 20,
              currentPage: 1,
            }}
            onActionChange={actionHandler}
            isLoading={isXmlSchemaReportFetching || isloadingData}
            onRowSelect={handleRowSelect}
          />
        </div>
      </div>
      <CenterModal
        modalTitle={`Mapping XML Schema Field : ${selectedRow?.schemaFieldName}`}
        modalSize={"w-35"}
        isOpen={isXSDTemplateModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <MappingSchemaField selectRow={selectRow} reportTemplateID={reportTemplateID} xmlTemplateId={xmlTemplateId} xmlReportId={xmlReportId} selectedRow={selectedRow} onSuccess={handleSucces} onClose={handleCloseModel}/> 
      </CenterModal>
    </div>
  );
};

ViewSchemaFieldModel.prototype = {
  reportTemplateID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xmlReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xmlTemplateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default ViewSchemaFieldModel;
